import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import About from "./pages/About";
import Adminorders from "./pages/Adminorders";
import Adminpannel from "./pages/Adminpannel";
import Adminproducts from "./pages/Adminproducts";
import Adminusers from "./pages/Adminusers";
import Cartpage from "./pages/Cartpage";
import Homepage from "./pages/Homepage";
import Loginpage from "./pages/Loginpage";
import Orders from "./pages/Orders";
import ProductDetails from "./pages/ProductDetails";
import Products from "./pages/Products";
import Registerpage from "./pages/Registerpage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Homepage />} />
          <Route path="/about" exact element={<About />} />
          <Route path="/login" exact element={<Loginpage />} />
          <Route path="/register" exact element={<Registerpage />} />
          <Route
            path="/cart"
            exact
            element={
              <ProtectedRoutes>
                <Cartpage />
              </ProtectedRoutes>
            }
          />
          <Route path="/products" exact element={<Products />} />
          <Route
            path="/orders"
            exact
            element={
              <ProtectedRoutes>
                <Orders />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/productdetails/:productid"
            exact
            element={<ProductDetails />}
          />
          <Route
            path="/admin"
            exact
            element={
              <ProtectedRoutes>
                <AdminProtectedRoutes>
                  <Adminpannel />
                </AdminProtectedRoutes>
              </ProtectedRoutes>
            }
          />
          <Route
            path="/admin/users"
            exact
            element={
              <ProtectedRoutes>
                <AdminProtectedRoutes>
                  <Adminusers />
                </AdminProtectedRoutes>
              </ProtectedRoutes>
            }
          />
          <Route
            path="/admin/products"
            exact
            element={
              <ProtectedRoutes>
                <AdminProtectedRoutes>
                  <Adminproducts />
                </AdminProtectedRoutes>
              </ProtectedRoutes>
            }
          />
          <Route
            path="/admin/orders"
            exact
            element={
              <ProtectedRoutes>
                <AdminProtectedRoutes>
                  <Adminorders />
                </AdminProtectedRoutes>
              </ProtectedRoutes>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

export const ProtectedRoutes = ({ children }) => {
  if (localStorage.getItem("currentUser")) {
    return children;
  } else {
    return <Navigate to="/login" />;
  }
};

export const AdminProtectedRoutes = ({ children }) => {
  if (
    JSON.parse(localStorage.getItem("currentUser")).user.uid ===
    "YUBGLLymJ4XBaxAEwtd0TweS32u2"
  ) {
    return children;
  } else {
    return (
      <Layout>
        <h2>You are not an admin</h2>
      </Layout>
    );
  }
};
